import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, change, changeType, icon, color, previewMode = false }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'green':
        return {
          bg: 'bg-success/10',
          icon: 'text-success',
          border: 'border-success/20'
        };
      case 'amber':
        return {
          bg: 'bg-warning/10',
          icon: 'text-warning',
          border: 'border-warning/20'
        };
      case 'red':
        return {
          bg: 'bg-error/10',
          icon: 'text-error',
          border: 'border-error/20'
        };
      default:
        return {
          bg: 'bg-primary/10',
          icon: 'text-primary',
          border: 'border-primary/20'
        };
    }
  };

  const colorClasses = getColorClasses();

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow">
      {/* Preview Mode Badge */}
      {previewMode && (
        <div className="mb-2">
          <span className="text-xs bg-amber-100 text-amber-800 px-2 py-1 rounded-full">
            Preview Data
          </span>
        </div>
      )}

      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-xs sm:text-sm text-muted-foreground mb-1 sm:mb-2">{title}</p>
          <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-foreground">{value}</p>
          <div className="flex items-center gap-1 mt-1 sm:mt-2">
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
              size={14} 
              className={changeType === 'positive' ? 'text-green-600' : 'text-red-600'} 
            />
            <span className={`text-xs sm:text-sm font-medium ${
              changeType === 'positive' ? 'text-green-600' : 'text-red-600'
            }`}>
              {change}
            </span>
            <span className="text-xs text-muted-foreground ml-1">vs last month</span>
          </div>
        </div>
        <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center ${colorClasses.bg}`}>
          <Icon name={icon} size={18} color={colorClasses.icon} className="sm:w-5 sm:h-5" />
        </div>
      </div>
    </div>
  );
};

export default KPICard;